import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Employee } from 'src/app/classes/employee';
import { Feedback } from 'src/app/classes/feedback';
import { FeedbackService } from 'src/app/services/feedback.service';
import * as fa from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent  implements OnInit {
  feedbacks: Feedback[] = []
  employee!: Employee

  fa = fa
  
  constructor(public activeModal: NgbActiveModal,
    private feedbackService: FeedbackService
  ) { }

  ngOnInit() {
    this.feedbackService.employee(this.employee.id).subscribe(feedbacks => {
      this.feedbacks = feedbacks
    })
  }

}
